// router/guards/index.ts
import type { NavigationGuard } from 'vue-router'
import { useAuthStore } from '@/store/auth-store'
import { storeToRefs } from 'pinia'
import { Routes } from '@/config/router/routes'

export const createAuthGuard = (options: {
  requiresAuth?: boolean
  requiredRole?: string
  requiresGuest?: boolean
  onlyUnAuthorized?: boolean
}): NavigationGuard => {
  return async (to, from, next) => {
    const authStore = useAuthStore()
    const { isAuthenticated } = storeToRefs(authStore)

    if (options.onlyUnAuthorized && isAuthenticated.value) {
      next({ path: '/'})
    }

    authStore.checkAuth()

    if (options.requiresAuth && !isAuthenticated.value) {
      next({ name: Routes.Login, query: { redirect: to.fullPath } })
      return
    }

    if (options.requiresGuest && isAuthenticated) {
      next({ name: Routes.Chat })
      return
    }

    /* if (options.requiredRole) {
      if (authStore user?.role !== options.requiredRole) {
        next({ name: 'forbidden' })
        return
      }
    } */

    next()
  }
}
